import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectService} from "@catcore/services";
import {isNullOrUndefined} from "util";
import {ExplorerItem, TreeNodeInfo} from "@catui/types";
import {Router} from "@angular/router";
import {Project} from "@catcore/types/api-v2";
import {ProjectSpeakerSetupService} from "@catmodels/project-speaker-setup/services/project-speaker-setup.service";

@Component({
  selector: 'cat-project-speaker-setup',
  templateUrl: './project-speaker-setup.component.html',
  styleUrls: ['./project-speaker-setup.component.scss']
})
export class ProjectSpeakerSetupComponent implements OnInit,  OnDestroy {
  doAllowCreate = false;
  activeItem = false;
  explorerItems: ExplorerItem[] = [];
  subscription = null;

  constructor(private projectService: ProjectService,
              private router: Router,
              private projectSpeakerSetupService: ProjectSpeakerSetupService) {
  }

  navigateTo(node: TreeNodeInfo) {
    this.router.navigate(node.item.value.route);

  }

  ngOnInit() {
    this.subscription = this.projectService
      .getCurrentProject()
      .subscribe((project: Project) => {
        if (!isNullOrUndefined(project)) {
          this.explorerItems = [];
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Input Assignment', 'input-assignment'));
        }
      });
    this.projectSpeakerSetupService.setActive();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.projectSpeakerSetupService.setInActive();
  }
}

const buildDefaultExplorerItem = (project: Project, displayName: string, targetRef: string): ExplorerItem => {
  return {label: displayName, value: {route: ['projects', `${project.id}`, 'speaker-setup', targetRef]}, expanded: false, allowedActions: []};
};




// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/project-speaker-setup/components/project-speaker-setup/project-speaker-setup.component.ts